module.exports = __webpack_public_path__ + "7b8be8ab0627cafb2ff058f9e431de36.MP3";